module.exports = __webpack_public_path__ + "static/media/ic_03_extend.8149772d.svg";